var React = require('react');

function JkLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"JK Design"),React.createElement("g",{"id":"f648e203-a312-4219-85e4-33775833d739","data-name":"Group 4219","key":1},[React.createElement("rect",{"id":"ebcfbd93-ace1-4b18-abcf-b34e25b4a91b","data-name":"Rectangle 1138","x":"34.59","width":"3.4","height":"3.4","key":0}),React.createElement("path",{"id":"fb62a224-2644-4b73-861b-a963224c0370","data-name":"Path 7438","d":"M30.76,7.25H34.6V38H0V3.4H30.76ZM27.6,29.12l-6.53-9L27,11.83H22.59l-5.15,7.31v-7.3h-3.7V23.48c0,1.8-1,2.95-2.5,2.95a2.39,2.39,0,0,1-2.45-2.31v-.18H5.08V24a6.18,6.18,0,0,0,12.35-.29V21.35L23,29.12Z","transform":"translate(0)","key":1})])]);
}

JkLogo.defaultProps = {"className":"fill-current","id":"e5b09617-09a9-42b0-9e95-904d73a0cfdd","data-name":"Layer 1","viewBox":"0 0 38 38","width":"38","height":"38"};

module.exports = JkLogo;

JkLogo.default = JkLogo;
